/* eslint-disable no-unused-expressions */
window.federationHost = window.location.hostname === 'localhost'
  ? 'https://test.coding.qq.com'
  : `https://${window.location.hostname}`;

if (!window.packageManagerVersion) {
  window.packageManagerVersion = 'stable';
}

import('./bootstrap');
